import { SupabaseClient } from '@supabase/supabase-js';
import camelcaseKeys from 'camelcase-keys';

import { Database, withLogs } from '@core';

const USER_CLUBS_QUERY = 'club:clubs(*)' as const;

export const fetchUserClubs = withLogs(async (supabase: SupabaseClient<Database>, userId: string) => {
    const { data, error } = await supabase.from('user_golf_bag').select(USER_CLUBS_QUERY).eq('user_id', userId);
    if (error) {
        throw error;
    }

    return camelcaseKeys(data, { deep: true }).map(({ club }) => club);
}, 'fetchUserClubs');

export const removeUserClub = withLogs(async (supabase: SupabaseClient<Database>, userId: string, clubId: number) => {
    const { error } = await supabase.from('user_golf_bag').delete().eq('user_id', userId).eq('club_id', clubId);
    if (error) {
        throw error;
    }
}, 'removeUserClub');

export const addUserClub = withLogs(async (supabase: SupabaseClient<Database>, userId: string, clubId: number) => {
    const { error } = await supabase.from('user_golf_bag').insert({
        user_id: userId,
        club_id: clubId,
    });
    if (error) {
        throw error;
    }
}, 'addUserClub');

export const addUserClubs = withLogs(async (supabase: SupabaseClient<Database>, userId: string, clubIds: number[]) => {
    if (clubIds.length === 0) {
        return;
    }

    const { error } = await supabase.from('user_golf_bag').insert(
        clubIds.map((clubId) => ({
            user_id: userId,
            club_id: clubId,
        })),
    );

    if (error) {
        throw error;
    }
}, 'addUserClubs');
